import { useRouter } from "next/router";
import styled from "styled-components";
import { mediaMaxWidth } from "../../utils/mediaQuery";
import Mixpanel from "../../utils/Mixpanel";
import config from "../../config";
import Button from "../Buttons/Button";
import useBranchIoLinkGeneration from "../../utils/BranchIO";
import { getUrlPath } from "../../utils/helpers";
import {
	BRANCH_APP_DOWNLOAD_CAMPAIGNS,
	GOOGLE_CLOUD_STORAGE_BASE_URL,
} from "../../utils/constants";

const HeaderActionBar = ({ border, isEmployerPage, source, customUtmMedium }) => {
	const router = useRouter();
	const [url] = useBranchIoLinkGeneration({
		campaign: BRANCH_APP_DOWNLOAD_CAMPAIGNS.playStoreIcon,
		section: "Header Google Play Icon",
		pageType: source,
		customUtmMedium,
	});
	const trackEmployerPostJob = () => {
		Mixpanel.track("Header page post a job click", {
			page: getUrlPath(),
			source: "Post Job Button",
		});
	};
	const trackEmployerLogin = () => {
		Mixpanel.track("Header Employer Login click", {
			page: getUrlPath(),
			source: "Employer Login Button",
		});
	};

	return (
		<RightActionBarContainer>
			<PostJobBtn
				className="h-mobile"
				as="a"
				href={`${config.dashboardUrl}/login?utm_source=${
					(router.query && router.query.utm_source) || "Website"
				}&utm_medium=${
					(router.query && router.query.utm_medium) || "Post%20Job%20Button"
				}&utm_campaign=${
					(router.query && router.query.utm_campaign) || "JobListingPage"
				}&employer=true`}
				id="cta-banner-job-typeform-btn"
				target="_blank"
				rel="noopener noreferrer"
				onClick={trackEmployerPostJob}
			>
				Post a Job now
			</PostJobBtn>
			<EmpLoginBtn
				className="h-mobile"
				secondary
				as="a"
				href={`${config.dashboardUrl}/login?utm_source=${
					(router.query && router.query.utm_source) || "Website"
				}&utm_medium=${
					(router.query && router.query.utm_medium) ||
					"Employer%20Login%20Button"
				}&utm_campaign=${
					(router.query && router.query.utm_campaign) || "JobListingPage"
				}&employer=true`}
				id="cta-banner-employer-portal-btn"
				target="_blank"
				rel="noopener noreferrer"
				border={border}
				onClick={trackEmployerLogin}
			>
				Employer Login
			</EmpLoginBtn>
			{/* <PostJobBtn className="h-mobile">Post a Job</PostJobBtn>
			<EmpLoginBtn className="h-mobile">Employer login</EmpLoginBtn> */}
			{!isEmployerPage && (
				<PlayStoreLink
					className="d-mobile"
					href={url}
					id="playstore-header-link"
					target="_blank"
					rel="noopener noreferrer"
					onClick={() => {
						Mixpanel.track("Header Google Play Icon Click", {
							"Profile URL":
								typeof window !== "undefined" && window.location.href,
							Source: `Job_Listing_Page`,
							page: getUrlPath(),
						});
					}}
				>
					<Image
						src={`${GOOGLE_CLOUD_STORAGE_BASE_URL}/website/play-store-badge.png`}
						alt="Apna Play Store Image Link"
						loading="lazy"
					/>
				</PlayStoreLink>
			)}
		</RightActionBarContainer>
	);
};

const RightActionBarContainer = styled.div`
	display: flex;
	align-items: center;
	.d-mobile {
		display: none;
		${mediaMaxWidth.medium`
            display: block;`};
	}
	.h-mobile {
		display: block;
		${mediaMaxWidth.medium`
            display: none;`};
	}
`;
const PostJobBtn = styled(Button)`
	height: 32px;
	border-radius: 4px;
	background-color: #2bb793;
	font-size: 14px;
	font-weight: 900;
	color: #ffffff;
	padding: 0px 14px;
	margin-right: 12px;
	border: none;
	outline: none;
	line-height: 32px;
	text-decoration: none;
	&:hover {
		box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.39);
	}
`;
const EmpLoginBtn = styled(Button)`
	height: 32px;
	background-color: #4d3951;
	font-size: 14px;
	font-weight: 900;
	padding: 0px 14px;
	border: ${(props) => (props.border ? props.border : "none")};
	outline: none;
	color: #ffffff;
	line-height: 32px;
	text-decoration: none;
	&:hover {
		box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.39);
		border: none;
	}
`;
const PlayStoreLink = styled.a``;
const Image = styled.img`
	max-width: 105px;
`;

export default HeaderActionBar;
